module.exports = __webpack_public_path__ + "img/img_5.868a5980.png";